import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const DEMO_URL = 'https://multiserviciosja.cl/?gad_source=1&gad_campaignid=22311938529&gbraid=0AAAAA_As8u7AKQNfdH6zTAuSI1YQd_eS4&gclid=CjwKCAjw7KvTBhA6EiwAWnutYT5697ZFCAS8or7cXF2KNoLtWP4derDCkE_CNvAA9stuEmzpPfO_cxoCH50QAvD_BwE';
const ESTETICA_URL = 'https://romedicalart.com/pages/corporal?utm_source=Google_CPC&utm_medium=Search&utm_content=Tratamientos-Tonificadores&utm_campaign=Palermo&gad_source=1&gad_campaignid=23973576387&gbraid=0AAAAACie59KDYctiZ6r1JgXeUoOiKDWTT&gclid=CjwKCAjw7KvTBhA6EiwAWnutYc7TqzsmaEm4hPoRH-7-Gz6UcGAvIh_EXUHYHzmy8rcoz4npTwzHxRoCsEoQAvD_BwE';
const works = [{
  title: 'Taller mecánico',
  category: 'Servicios',
  url: DEMO_URL,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/133b24f7-2404-4f6d-9793-56658a4846c8.jpg'
}, {
  title: 'Estética',
  category: 'Belleza',
  url: ESTETICA_URL,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1ab1aabe-aa0b-4ba9-8666-724452bb4697.jpg'
}, {
  title: 'Restaurante',
  category: 'Gastronomía',
  url: DEMO_URL,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4101793e-9653-48b7-befe-e052dca4fdb0.jpg'
}, {
  title: 'Abogado',
  category: 'Profesional',
  url: DEMO_URL,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/dd1a525e-fcad-4c42-adbc-4c9e991a61b7.jpg'
}];
export function Examples() {
  return <section id="ejemplos" className="w-full bg-[#FAFAFA] py-20 sm:py-28" data-id="element-40" data-mp="2r8i0zftkizlg">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-41" data-mp="3577xouch6x9a">
        <SectionHeading eyebrow="Ejemplos de trabajos" title="Webs reales, entregadas en un día" description="Diseños pensados para cada rubro, con foco en que el cliente te escriba." data-id="element-42" data-mp="31779ihzkr7p1" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-43" data-mp="16ty71a5g4mga">
          {works.map((work, index) => <motion.article key={work.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index % 3 * 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="group overflow-hidden rounded-3xl border border-black/5 bg-white shadow-soft transition-all hover:-translate-y-1 hover:shadow-lift" data-id="element-44" data-mp="35yy590k9okhe" data-mpi={index}>
              <div className="aspect-[4/3] w-full overflow-hidden bg-[#f2f2f2]" data-id="element-45" data-mp="3tuk5e6e7ue2x">
                <img src={work.image} alt={`Ejemplo de página web para ${work.title.toLowerCase()}`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]" loading="lazy" data-id="element-46" data-mp="2gefc4p29qpr" />
              </div>
              <div className="flex items-center justify-between gap-4 p-6" data-id="element-47" data-mp="gh8oipjxnvph">
                <div data-id="element-48" data-mp="20yzx5mi3xzn6">
                  <span className="text-[11px] font-bold uppercase tracking-[0.15em] text-brand-ink/40" data-id="element-49" data-mp="210b4fwarhpj1">
                    {work.category}
                  </span>
                  <h3 className="mt-1 text-base font-bold" data-id="element-50" data-mp="1rxjrfs28mlpa">{work.title}</h3>
                </div>
                <a href={work.url} target="_blank" rel="noopener noreferrer" aria-label={`Ver sitio de ejemplo: ${work.title}`} className="inline-flex items-center gap-1.5 rounded-full border border-black/10 px-4 py-2 text-xs font-bold text-brand-ink transition-colors group-hover:border-brand-yellow group-hover:bg-brand-yellow" data-id="element-51" data-mp="1mzi4gw1oy28j">
                  Ver sitio
                  <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="25w04s1ulvage" />
                </a>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}